import {VehiclePhoto} from '@dms/api/shared';

export type SimilarVehicle = {
  id: string;
  make: string;
  title: string;
  modelFamily: string;
  customMake: string | null;
  customModelFamily: string | null;
  vin: string | null;
  registrationPlate: string | null;
  isArchived: boolean | null;
  photos: VehiclePhoto[];
  type?: SimilarVehicle.type | null;
  trim?: string | null;
  variant?: string | null;
  fuelType?: string | null;
  transmission?: string | null;
  bodyStyle?: string | null;
  drive?: string | null;
  firstRegistration?: string | null;
  realProductionYear?: string | null;
  mileage?: number | null;
  secondaryFuelType?: string | null;
  features?: any[] | null; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  power?: number | null;
  saleVehicleId?: string | null;
  serviceVehicleId?: string | null;
};

export namespace SimilarVehicle {
  export enum type {
    VEHICLETYPE_PASSENGER_CAR = 'VEHICLETYPE_PASSENGER_CAR',
    VEHICLETYPE_VAN = 'VEHICLETYPE_VAN',
    VEHICLETYPE_MOTORCYCLE = 'VEHICLETYPE_MOTORCYCLE',
    VEHICLETYPE_TRUCK = 'VEHICLETYPE_TRUCK',
    VEHICLETYPE_SEMI_TRAILER = 'VEHICLETYPE_SEMI_TRAILER',
    VEHICLETYPE_TRAILER = 'VEHICLETYPE_TRAILER',
    VEHICLETYPE_BUS = 'VEHICLETYPE_BUS',
    VEHICLETYPE_CARAVAN = 'VEHICLETYPE_CARAVAN',
    VEHICLETYPE_OTHER = 'VEHICLETYPE_OTHER',
    VEHICLETYPE_AGRICULTURAL_MACHINE = 'VEHICLETYPE_AGRICULTURAL_MACHINE',
    VEHICLETYPE_CONSTRUCTION_MACHINE = 'VEHICLETYPE_CONSTRUCTION_MACHINE',
  }
}
